import React from 'react';
import {
    formatAmountFull,
    formatNumber,
    needsAmountTooltip,
    parseAmountValue,
} from '../../utils/amountFormat';

/**
 * Renders a formatted token/payment amount with an optional themed hover tooltip
 * showing the full precision value when the display is abbreviated or rounded.
 */
const AmountDisplay = ({
    value,
    className = '',
    suffix = '',
    suffixClassName = 'ml-1 text-[11px] font-medium text-zinc-500 dark:text-zinc-400',
    as: Tag = 'span',
    tabular = true,
}) => {
    const n = parseAmountValue(value);
    const display = formatNumber(n);
    const showTip = needsAmountTooltip(n);
    const tipText = suffix
        ? `${formatAmountFull(n)} ${suffix}`.trim()
        : formatAmountFull(n);
    const baseClass = tabular ? 'tabular-nums' : '';

    const content = (
        <>
            {display}
            {suffix ? <span className={suffixClassName}>{suffix}</span> : null}
        </>
    );

    if (!showTip) {
        return (
            <Tag className={`${baseClass} ${className}`.trim()}>
                {content}
            </Tag>
        );
    }

    return (
        <Tag
            className={`group/amt relative inline-flex max-w-full items-baseline ${baseClass} ${className}`.trim()}
            title={tipText}
        >
            {content}
            <span
                role="tooltip"
                className="pointer-events-none absolute bottom-[calc(100%+8px)] left-1/2 z-[100] -translate-x-1/2 whitespace-nowrap rounded-lg border border-zinc-200 bg-white px-2.5 py-1.5 text-[11px] font-medium text-zinc-800 opacity-0 shadow-md shadow-zinc-900/10 transition-opacity duration-150 group-hover/amt:opacity-100 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-100 dark:shadow-black/50"
            >
                {tipText}
                <span
                    className="absolute left-1/2 top-full -translate-x-1/2 border-[5px] border-transparent border-t-white dark:border-t-zinc-900"
                    aria-hidden
                />
            </span>
        </Tag>
    );
};

export default AmountDisplay;
